<template>
  <VNavigationDrawer
    v-model="drawerStatus"
    :clipped="$vuetify.breakpoint.mdAndUp"
    fixed
    app
  >
    <VList
      dense
      class=" grey--text text--darken-3"
    >
      <template v-for="item in items">
        <VListGroup
          v-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon=""
        >
          <VListTile slot="activator">
            <VListTileContent>
              <VListTileTitle>
                {{ item.text }}
              </VListTileTitle>
            </VListTileContent>
          </VListTile>
          <VListTile
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.route"
          >
            <VListTileAction v-if="child.icon">
              <VIcon>{{ child.icon }}</VIcon>
            </VListTileAction>
            <VListTileContent>
              <VListTileTitle>
                {{ child.text }}
              </VListTileTitle>
            </VListTileContent>
          </VListTile>
        </VListGroup>
        <VListTile
          v-else
          :key="item.text"
          :to="item.route"
        >
          <VListTileAction>
            <VIcon>{{ item.icon }}</VIcon>
          </VListTileAction>
          <VListTileContent>
            <VListTileTitle>
              {{ item.text }}
            </VListTileTitle>
          </VListTileContent>
        </VListTile>
      </template>
    </VList>
  </VNavigationDrawer>
</template>

<script>
export default {
  name: 'NavigationDrawer',
  data: function () {
    return {
      items: [
        { icon: 'contacts', text: 'Contacts', route: { name: 'contacts' } },
        { icon: 'groups', text: 'Groups', route: { name: 'groups' } },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'Explore',
          model: true,
          children: [
            { icon: 'bookmark', text: 'Category', route: { name: 'categories' } },
            { icon: 'favorite', text: 'Interest', route: { name: 'interests' } },
            { icon: 'mdi-vote', text: 'Polling', route: { name: 'polling' } }
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          text: 'More',
          model: false,
          children: [
            { icon: 'cloud_upload', text: 'Import Contacts', route: { name: 'importContacts' } },
            { icon: 'mdi-calendar-star', text: 'Automation', route: { name: 'automationRules' } }
          ]
        },
        { icon: 'settings', text: 'Settings' },
        { icon: 'chat_bubble', text: 'Send feedback' },
        { icon: 'help', text: 'Help' },
        { icon: 'phonelink', text: 'App downloads' }
      ]
    }
  },
  computed: {
    drawerStatus: {
      get () {
        return this.$store.state.navigationDrawer.visible
      },
      set (val) {
        this.$store.dispatch('navigationDrawer/setVisibility', { val })
      }
    }
  }
}
</script>

<style scoped>

</style>
